import { createContext, useContext } from 'react'

const SignaturesDropdownsContext = createContext(null)

export const useSignaturesDropdownContainer = () => {
  const context = useContext(SignaturesDropdownsContext)

  if (!context) {
    // Temp fix for thumbnails
    return {}
  }

  return context
}

export const SignaturesDropdownsContextProvider = SignaturesDropdownsContext.Provider
